import { useIntl } from 'gatsby-plugin-intl';
import React, { FC, useEffect } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import { useNavigation } from 'hooks/navigation';

import { useSession } from '../../providers';
import { saveUserLoginRedirectURL } from '../../utils/logout';
import { OnlyWhenAuthenticated } from '../OnlyWhenAuthenticated';

export const Authenticated: FC = ({ children }) => {
  const [isAuthenticated] = useSession();

  const redirectToSignIn = useNavigation(ROUTER_PATHS.SIGN_IN);
  const { locale } = useIntl();

  useEffect(() => {
    if (!isAuthenticated) {
      saveUserLoginRedirectURL(locale);
      redirectToSignIn();
    }
  }, [isAuthenticated]);

  return <OnlyWhenAuthenticated>{children}</OnlyWhenAuthenticated>;
};
